<template>
  <div class="container">
    <div class="flex-wrap flex-between" style="height:60px;padding:0 20px;">
      <div class="flex-wrap">
        <h2 style="color:var(--text3);font-size:17px;">运营数据总览</h2>
      </div>
      <div class="flex-wrap">
        <!-- <CmFilter /> -->
      </div>
    </div>

    <div style="height:calc(100% - 60px);background:var(--bg3);border-top:1px solid var(--border);position:relative;overflow-y:auto;padding-bottom:20px;">
      <Spin fix v-if="loading">
        <div class="flex-wrap flex-col" style="margin:0 auto;margin-top:15%;width:240px;">

            <Progress status="active" :percent="loading.percent" style="margin-bottom:10px" />
            {{loading.status}}
        </div>
      </Spin>

  <BaseLayout v-else class="container" flex :panels="panels"  :padding="20" :gutter="20">

  </BaseLayout>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CmFilter from '@/components/cm/Filter';
export default {
  components: {CmFilter},
  mounted() {
    setTimeout(()=>{
      this.$store.dispatch('cm/getData').then(()=>{
        this.$store.dispatch('cm/getPermissionDeps').then(()=>{
          this.$store.commit('cm/calcTotal');
          this.$store.commit('cm/endComputing');
        }).catch(()=>{
          this.$store.commit('cm/endComputing');
        });
      });
    }, 500);
  },
  computed: {

    ...mapGetters('cm', ['projects', 'computingTotal', 'loading', 'my_role']),
    panels() {
      return [{
        control: 'PanelCmDProjects',
        w: 10, h: 5.5,
      }, {
        control: 'PanelCmDContract',
        w: 12, h: 7,
      },
      {
        control: 'PanelCmDProgress',
        w: 10, h: 7.5,
      },
      {
        control: 'PanelCmDHr',
        x: 8, y: 6.5, w: 12, h: 7,
      },
      {
        control: 'PanelCmDAvgHrp',
        x: 0, y: 5.5, w: 10, h: 5.5,
      },
      {
        control: 'PanelEmpty',
        x: 0, y: 5.5, w: 12, h: 5.5,
      },


      ];
    },
  },
};
</script>

<style lang="less">
.billboard-item{
  width:300px;
  height:200px;
  img{
    width:100%;
    height:calc(100% - 30px);
  }

  .b-name{
    height:30px;
    width:100%;
    text-align: center;
    font-size:16px;
  }
}
</style>
